module.exports = __webpack_public_path__ + "static/media/club180darts.79d903c2.jpg";